import { render, staticRenderFns } from "./ReturnAddress.vue?vue&type=template&id=260fbfee&scoped=true"
import script from "./ReturnAddress.vue?vue&type=script&lang=js"
export * from "./ReturnAddress.vue?vue&type=script&lang=js"
import style0 from "./ReturnAddress.vue?vue&type=style&index=0&id=260fbfee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260fbfee",
  null
  
)

export default component.exports